exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dis-flex{display:flex}.pageTitleCom{width:100%;height:10.66667vw;font-size:4.26667vw;color:#333;background:white;display:flex;flex-direction:row;align-items:center;justify-content:center;overflow:hidden}.pageTitleCom.dark{background:#000;color:white}\n", ""]);

// exports
